import React from 'react'
import PropTypes from 'prop-types'
import AppLink from 'Components/AppLink'
import { useLocation } from 'react-router'
import IconWithValue from 'Components/ListingPreview/components/IconWithValue'
import { _SideLinkContent } from './styles'

const SideLink = ({ iconName, url = '', alt, label, svgSize = 20 }) => {
  const { pathname } = useLocation()
  const isActive = !!(url.match(pathname))
  return (
    <AppLink alt={alt} to={url}>
      <_SideLinkContent
        data-test-id="linkBackground"
        active={isActive}
        align="center"
      >
        <IconWithValue
          iconName={iconName}
          value={label}
          svgSize={svgSize}
        />
      </_SideLinkContent>
    </AppLink>
  )
}

SideLink.propTypes = {
  iconName: PropTypes.string,
  url: PropTypes.string.isRequired,
  label: PropTypes.string,
  alt: PropTypes.string,
  svgSize: PropTypes.number,
}

export default SideLink
